import { Button, Image } from "react-bootstrap";
import "../../assets/scss/components/templates/button.scss";

function Btn(props) {
  return (
    <Button
      className={`${props.class} z-2 position-relative`}
      onClick={props.handle}
    >
      <Image src={props.imgSrc} className={"imgSrc" in props ? "me-2" : ""} />
      <span>{props.text}</span>
    </Button>
  );
}

export default Btn;
